import React from "react";
import { ToastContainer } from "react-toastify";
import useViewSize from "../../hooks/use-view-size";

const CustomToastContainer = () => {
  const { width } = useViewSize();

  return (
    <ToastContainer
      bodyClassName="toast-body"
      toastClassName="toast-container"
      position={width <= 768 ? "top-center" : "bottom-right"}
      autoClose={3000}
      closeButton={false}
      limit={2}
    />
  );
};

export default CustomToastContainer;